<template>
  <v-menu :close-on-content-click="false" left offset-y rounded="xl">
    <template #activator="{ on }">
      <vs-button :disabled="disabled" class="ml-2" icon="mdi-tune" type="secondary" v-on="on">
        <v-icon>mdi-tune</v-icon>
      </vs-button>
    </template>

    <v-list flat>
      <v-subheader class="d-flex justify-space-between">
        Status
        <select-all-toggle
          :selected-item-count="selectedFilters.length"
          :total-item-count="filterOptions.length"
          @toggle="toggleAll"
        />
      </v-subheader>

      <v-list-item-group v-model="model" multiple>
        <v-list-item v-for="{ id, name, count } in filterOptions" :key="id">
          <template #default="{ active }">
            <v-list-item-action>
              <v-checkbox :input-value="active"></v-checkbox>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{ name }} ({{ count }})</v-list-item-title>
            </v-list-item-content>
          </template>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
import SelectAllToggle from '@/components/common/SelectAllToggle.vue'
import { computed } from 'vue'

const props = defineProps<{
  value: { id: string; name: string }[]
  filterOptions: { count: never; id: string; name: string }[]
  disabled?: boolean
}>()

const emit = defineEmits(['input'])

const selectedFilters = computed(() =>
  props.value.map((f) => props.filterOptions.findIndex((o) => o.id === f.id)),
)

const model = computed({
  get() {
    return selectedFilters.value
  },
  set(newValue: number[]) {
    emit(
      'input',
      props.filterOptions.filter((_, i) => newValue.includes(i)),
    )
  },
})

function toggleAll(isAllSelected: boolean) {
  if (isAllSelected) {
    model.value = []
  } else {
    model.value = props.filterOptions.map((_, i) => i)
  }
}
</script>

<style scoped></style>
